import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class SalesLostReasonService {

  constructor(private ws: PostmethodService) { }

  salesReasonCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "salesLostReasonsMaster");
  }
}
